import React from "react";

export default function EventSection({ dark }: { readonly dark: boolean }) {
  const images = Array.from({ length: 10 }, (_, i) => `/assets/${i + 1}.webp`);

  return (
    <section
      className="w-full py-12 md:py-24 lg:py-24 overflow-hidden"
      style={{ backgroundColor: dark ? "#1f2937" : "white" }}
      id="gallery"
    >
      <div className="container px-4 md:px-6 mx-auto">
        <h2
          className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-16"
          style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
        >
          Event Gallery
        </h2>
        <div className="flex flex-col gap-8">
          {/* First Row */}
          <div className="marquee">
            <div className="track">
              {[...images.slice(0, 5), ...images.slice(0, 5)].map((src, i) => (
                <div key={`${src}-${i}`} className="marquee-item">
                  <img
                    src={src}
                    alt={`Photo ${i + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
          {/* Second Row */}
          <div className="marquee reverse">
            <div className="track">
              {[...images.slice(5), ...images.slice(5)].map((src, i) => (
                <div key={`${src}-${i}`} className="marquee-item">
                  <img
                    src={src}
                    alt={`Event ${i + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
